import React, { Fragment } from "react";
import { createPortal } from "react-dom";
import WModal from "@/components/wmodal/WModal";
import { WTypography } from "@/components";
import Circle from "./components/Circle/Circle";
import { composeContainers } from "@/utils/composeContainers";
import { withModal } from "./containers/withModal";
import { withData } from "./containers/withData";
import { withImageResize } from "./containers/withImageResize";
import { Wrapper, Image } from "./styles";
import { ContainerProps, ViewProps } from "./types";

export default composeContainers<ViewProps, ContainerProps>({
  containers: [withData, withModal, withImageResize],
  component: ({
    imageRef,
    circles,
    imageDimensions,
    handleCircleClick,
    modal,
    handleCloseModal,
    details,
    image,
  }: ViewProps) => (
    <Fragment>
      <Wrapper>
        {/* Image */}
        <Image ref={imageRef} src={image} alt={image} />

        {/* Circles */}
        {circles.map((circle) => (
          <Circle
            key={circle.id}
            circle={circle}
            imageDimensions={imageDimensions}
            onClick={() => handleCircleClick(circle.details)}
          />
        ))}
      </Wrapper>
      {modal === "showDetails" &&
        createPortal(
          <WModal large backgroundColor="white" setModal={handleCloseModal}>
            <WTypography type="title" text={details?.title || ""} />
            <WTypography type="paragraph" text={details?.description || ""} />
            {details?.image && (
              <img src={details?.image} className="max-w-lg" alt="" />
            )}
          </WModal>,
          document.body
        )}
    </Fragment>
  ),
});
